import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[(_vm.$testMode)?_c('div',{staticClass:"test-mode"},[_vm._v("TEST MODE")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }